

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import { GeneratedRecommendationLetterItem } from '@/models/student/recommendation-letter';
import GStudentRecordRecommendationLetterList from './GStudentRecordRecommendationLetterList.vue';
import GStudentRecordRecommendationLetterEdit from './GStudentRecordRecommendationLetterEdit.vue';
import { ConfirmationStep } from '@/store/modules/entities/recommendation-letter.module';
import { recommendationLetterModule, RecommendationLetterStep } from '@/store/modules/entities/recommendation-letter.module';

@Component({
  name: 'GStudentRecordRecommendationLetterGeneration',
  components: {
    GStudentRecordRecommendationLetterList,
    GStudentRecordRecommendationLetterEdit,
  },
})
export default class GStudentRecordRecommendationLetterGeneration extends Vue {
  ConfirmationStep = ConfirmationStep;
  @Prop({ required: true }) student!: Student;

  get confirmationStep(): ConfirmationStep {
    return recommendationLetterModule.confirmationStep;
  }

  get generatedRecommendationLetters(): GeneratedRecommendationLetterItem[] {
    return recommendationLetterModule.generatedRecommendationLetters;
  }

  get selectedLetter(): GeneratedRecommendationLetterItem | null {
    return recommendationLetterModule.selectedRecommendationLetter;
  }

  get selectedRecommendationLetterId(): number | null {
    return recommendationLetterModule.selectedRecommendationLetterId;
  }

  handleRegenerateRecommendationLetter() {
    this.$Modal.confirm({
      title: this.$t('RECOMMENDATION_LETTER_CONFIRM_BACK_TO_STUDENT_INFO').toString(),
      content: this.$t('RECOMMENDATION_LETTER_CONFIRM_BACK_TO_STUDENT_INFO_CONTENT').toString(),
      onOk: () => {
        recommendationLetterModule.setGeneratedRecommendationLetters([]);
        recommendationLetterModule.setConfirmationStep(ConfirmationStep.Show);
        recommendationLetterModule.setCurrentStep(RecommendationLetterStep.StudentInfo);
      },
    });
  }

  handleEditRecommendationLetter() {
    recommendationLetterModule.setConfirmationStep(ConfirmationStep.Edit);
  }

  handleDownloadRecommendationLetter(selectedLetter: GeneratedRecommendationLetterItem): void {
    const content = selectedLetter.content;
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    // 推薦書のupdatedAtをYYYYMMDD_HHMMSS形式にフォーマット
    const updatedAt = new Date(selectedLetter.updatedAt);
    const year = updatedAt.getFullYear();
    const month = String(updatedAt.getMonth() + 1).padStart(2, '0');
    const day = String(updatedAt.getDate()).padStart(2, '0');
    const hours = String(updatedAt.getHours()).padStart(2, '0');
    const minutes = String(updatedAt.getMinutes()).padStart(2, '0');
    const seconds = String(updatedAt.getSeconds()).padStart(2, '0');
    const formattedDate = `${year}${month}${day}_${hours}${minutes}${seconds}`;

    a.download = `${selectedLetter.title}_${formattedDate}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  }

  selectRecommendationLetter(id: number) {
    recommendationLetterModule.setSelectedRecommendationLetterId(id);
  }

  tabButtonClass(id: number) {
    return {
      'tab-button': true,
      active: this.selectedRecommendationLetterId === id,
    };
  }

  recommendationItemClass(id: number) {
    return {
      'recommendation-item': true,
      selected: this.selectedRecommendationLetterId === id,
    };
  }

  handleCancelEdit() {
    recommendationLetterModule.setConfirmationStep(ConfirmationStep.Show);
  }
}
